module.exports = __webpack_public_path__ + "static/medal-miwc-silver-d6f1275c0f22e6d679fc4a59c9d1a89e.png";